import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { Icon, Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";

function Title({ title }) {
    return (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
            <SoftBox display="flex" flexDirection="column">
                <SoftTypography variant="button" fontWeight="medium">
                    {title}
                </SoftTypography>
            </SoftBox>
        </SoftBox>
    );
}
Title.defaultProps = {
    title: "",
};
Title.propTypes = {
    title: PropTypes.string.isRequired,
};

function Slug({ job }) {
    return (
        <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="caption" fontWeight="medium" color="text">
                {job}
            </SoftTypography>
        </SoftBox>
    );
}
Slug.defaultProps = {
    job: "",
};
Slug.propTypes = {
    job: PropTypes.string.isRequired,
};

function Actions({ currentBusinessEnquiryData, handleViewData }) {
    return <>
        <SoftButton variant="gradient" color="info" iconOnly={true} onClick={() => handleViewData(currentBusinessEnquiryData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleViewData(currentBusinessEnquiryData)}>
                visibility
            </Icon>
        </SoftButton>
    </>;
}
Actions.defaultProps = {
    currentBusinessEnquiryData: {},
    handleViewData: () => { }
};
Actions.propTypes = {
    currentBusinessEnquiryData: PropTypes.object.isRequired,
    handleViewData: PropTypes.func.isRequired
};
function businessEnquiryListing(businessEnquiryData, handleViewData) {
    return {
        columns: [
            { colummKey: "name", name: "Name", align: "left" },
            { colummKey: "email", name: "Email", align: "left" },
            { colummKey: "phone_number", name: "Contact Number", align: "left" },
            { colummKey: "enquiry_type", name: "Category", align: "left" },
            // { colummKey: "resolve_status", name: "Status", align: "left" },
            { colummKey: "source", name: "Source", align: "left" },
            { colummKey: "created_at", name: "Enquiry Date", align: "left" },
            { colummKey: "action", name: "Action", align: "center" },
        ],

        rows: businessEnquiryData ? businessEnquiryData.map((singleBusinessEnquiry, businessEnquiryIndex) => {
            return {
                name: <Title
                    title={singleBusinessEnquiry.name} />,
                email: <Slug
                    job={singleBusinessEnquiry.email} />,
                phone_number: <Slug
                    job={singleBusinessEnquiry.phone_number} />,
                enquiry_type: <Slug
                    job={singleBusinessEnquiry.enquiry_type} />,
                // resolve_status: <SoftBadge
                //     variant="gradient"
                //     badgeContent={
                //         singleBusinessEnquiry.resolve_status === 1 ?
                //             'Resolved' :
                //             'Pending'
                //     }
                //     color={
                //         singleBusinessEnquiry.resolve_status === 1 ?
                //             'success' :
                //             'secondary'
                //     }
                //     size="xs"
                //     container />,
                source: <Slug
                    job={singleBusinessEnquiry.source ?? "--"} />,
                created_at: <Slug
                    job={singleBusinessEnquiry.created_at} />,
                action: (
                    <Actions
                        currentBusinessEnquiryData={singleBusinessEnquiry}
                        handleViewData={handleViewData} />
                )
            };
        }) : [],
    };
};

export default businessEnquiryListing;
